<template>
  <div class="login">
    <div class="login__logo"></div>

    <!--    <div class="login__demo">Demo game</div>-->

    <router-view name="loginView" />

    <LoginBox v-if="!forgotPassword" v-on:forgotPassword="forgotPassword = true" />

    <ForgotPasswordBox v-else v-on:backToLogin="forgotPassword = false" />

    <LoginBg />
    <div class="login__videos">
      <div class="login__videos__video">
        <a href="https://vimeo.com/664260466/748d3d6904" target="_blank">
          <div class="login__videos__video__button">What is AdGame</div>
        </a>
      </div>
      <div class="login__videos__video">
        <a href="https://vimeo.com/664261088/e8ff4278b0" target="_blank">
          <div class="login__videos__video__button">Registration and joining a game</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LoginBox from "@/components/login/LoginBox.vue";
import LoginBg from "@/components/login/LoginBg.vue";
import ForgotPasswordBox from "@/components/login/ForgotPasswordBox.vue";

export default {
  name: "Login",
  components: {
    LoginBox,
    LoginBg,
    ForgotPasswordBox,
  },
  data() {
    return {
      forgotPassword: false,
    };
  },
};
</script>
